import moment from 'moment';

export const integrationEventStatusBadgeColor = (status) => {
    if (status === 'success') {
        return 'success';
    }
    if (status === 'failed') {
        return 'danger';
    }
    if (status === 'ignored') {
        return 'secondary';
    }
    return 'secondary';
};

const INTEGRATION_EVENT_KIND_LABELS = {
    psp_webhook: 'Webhook PSP',
    merchant_callback: 'Callback marchand',
    rest_api: 'API REST',
    request_form: 'Formulaire paiement',
};

const INTEGRATION_EVENT_STATUS_LABELS = {
    success: 'Succès',
    failed: 'Échec',
    ignored: 'Ignoré',
};

export const integrationEventKindLabel = (kind) =>
    (kind && INTEGRATION_EVENT_KIND_LABELS[kind]) || kind || '';

export const integrationEventStatusLabel = (status) =>
    (status && INTEGRATION_EVENT_STATUS_LABELS[status]) || status || '';

const PSP_WEBHOOK_EVENT_NAME_LABELS = {
    'wallee.create': 'Création',
    'wallee.pending': 'En attente',
    'wallee.confirmed': 'Confirmée',
    'wallee.processing': 'Traitement en cours',
    'wallee.failed': 'Échec',
    'wallee.authorized': 'Autorisée',
    'wallee.completed': 'Complétée',
    'wallee.fulfill': 'Prête à livrer',
    'wallee.decline': 'Refusée',
    'wallee.voided': 'Annulée',
    'wallee.scheduled': 'Planifiée',
    'wallee.manual_check': 'Contrôle manuel',
    'wallee.successful': 'Réussie',
    'wallee.unknown': 'État inconnu',
};

export const pspWebhookEventDisplayName = (name) => {
    const raw = String(name || '').trim();
    if (!raw) {
        return raw;
    }
    const key = raw.toLowerCase();
    return PSP_WEBHOOK_EVENT_NAME_LABELS[key] || raw;
};

const PSP_CHANNEL_DISPLAY_LABELS = {
    wallee: 'Wallee',
    stripe: 'Stripe',
    sumup: 'SumUp',
    datatrans: 'Datatrans',
};

export const pspChannelDisplayLabel = (channel) => {
    const raw = String(channel || '').trim().toLowerCase();
    if (!raw) {
        return '';
    }
    if (PSP_CHANNEL_DISPLAY_LABELS[raw]) {
        return PSP_CHANNEL_DISPLAY_LABELS[raw];
    }
    return raw.charAt(0).toUpperCase() + raw.slice(1);
};

export const pspWebhookPrimaryTitle = (channel, name) => {
    const psp = pspChannelDisplayLabel(channel);
    const eventLabel = pspWebhookEventDisplayName(name);
    return psp ? `${psp} · ${eventLabel}` : eventLabel;
};

export const formatIntegrationEventDateTime = (value) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }
    const m = moment(value);
    return m.isValid() ? m.format('LLL') : String(value);
};

/**
 * @returns {{ method: string, baseUrl: string, queryPairs: { key: string, value: string }[] }}
 */
export const parseMerchantCallbackName = (name) => {
    const trimmed = String(name || '').trim();
    const spaceIdx = trimmed.indexOf(' ');
    if (spaceIdx <= 0) {
        return { method: '', baseUrl: trimmed, queryPairs: [] };
    }
    const method = trimmed.slice(0, spaceIdx);
    const rest = trimmed.slice(spaceIdx + 1).trim();
    const qIdx = rest.indexOf('?');
    const baseUrl = qIdx >= 0 ? rest.slice(0, qIdx) : rest;
    const queryPairs = [];
    if (qIdx >= 0) {
        const qs = rest.slice(qIdx + 1);
        try {
            const sp = new URLSearchParams(qs);
            sp.forEach((value, key) => {
                queryPairs.push({ key, value });
            });
        } catch {
            // ignore
        }
    }
    return { method, baseUrl, queryPairs };
};

export const merchantCallbackTitleLine = (name) => {
    const { method, baseUrl } = parseMerchantCallbackName(name);
    if (!method) {
        return name;
    }
    return `${method} ${baseUrl}`;
};

export const urlWithoutQuery = (url) => {
    if (!url) {
        return '';
    }
    const s = String(url);
    const q = s.indexOf('?');
    return q >= 0 ? s.slice(0, q) : s;
};

export const integrationEventPrimaryTitle = (ev) => {
    if (!ev) {
        return '';
    }
    const { kind, name, channel } = ev;
    if (kind === 'merchant_callback' || kind === 'rest_api' || kind === 'request_form') {
        return merchantCallbackTitleLine(name);
    }
    if (kind === 'psp_webhook') {
        return pspWebhookPrimaryTitle(channel, name);
    }
    return name || '';
};
